import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import contentMap from '../generatedContent';
import './MarkdownPage.css';

export default function MarkdownPage({ pageId, onNavigate }) {
  const content = contentMap[pageId];

  if (!content) return <NotFound onNavigate={onNavigate} />;

  return (
    <div className="md-page">
      <ReactMarkdown
        className="md-body"
        remarkPlugins={[remarkGfm]}
        components={components}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

// ── Custom renderers ──────────────────────────────────────────────────────────
// These apply design-system styles to the raw HTML react-markdown produces.

const components = {
  // Headings
  h1: ({ children }) => <h1 className="md-h1">{children}</h1>,
  h2: ({ children, node }) => {
    const id = node.position?.start.line;
    return <h2 className="md-h2" id={`h-${id}`}>{children}</h2>;
  },
  h3: ({ children }) => <h3 className="md-h3">{children}</h3>,

  // Blockquote → callout
  blockquote: ({ children }) => (
    <div className="md-callout">{children}</div>
  ),

  // Code blocks
  code: ({ inline, className, children }) => {
    if (inline) return <code className="md-inline-code">{children}</code>;
    const lang = (className || '').replace('language-', '');
    return (
      <div className="md-code-block">
        {lang && <span className="md-code-lang">{lang}</span>}
        <pre><code>{children}</code></pre>
      </div>
    );
  },

  // Table
  table:   ({ children }) => <div className="md-table-wrap"><table className="md-table">{children}</table></div>,
  thead:   ({ children }) => <thead>{children}</thead>,
  tbody:   ({ children }) => <tbody>{children}</tbody>,
  tr:      ({ children }) => <tr>{children}</tr>,
  th:      ({ children }) => <th>{children}</th>,
  td:      ({ children }) => <td>{children}</td>,

  // Paragraph
  p:  ({ children }) => <p className="md-p">{children}</p>,

  // Lists
  ul: ({ children }) => <ul className="md-ul">{children}</ul>,
  ol: ({ children }) => <ol className="md-ol">{children}</ol>,
  li: ({ children }) => <li className="md-li">{children}</li>,

  // Horizontal rule → section divider
  hr: () => <hr className="md-hr" />,

  // Strong / em
  strong: ({ children }) => <strong className="md-strong">{children}</strong>,
};

// ── States ────────────────────────────────────────────────────────────────────

function NotFound({ onNavigate }) {
  return (
    <div className="md-page">
      <div className="md-not-found">
        <span className="md-not-found-code">404</span>
        <h1 className="md-h1">Page not found</h1>
        <p className="md-p md-not-found-text">
          The page you're looking for doesn't exist.
        </p>
        <button
          className="md-not-found-back"
          onClick={() => onNavigate('overview')}
        >
          Back to docs
        </button>
      </div>
    </div>
  );
}
